export default "__VITE_ASSET__a5bf812f__"